import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a8f9216"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questionnaire-cover" }
const _hoisted_2 = { class: "questionnaire__container" }
const _hoisted_3 = { class: "questionnaire__title" }
const _hoisted_4 = { class: "questionnaire__information" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_9 = {
  key: 0,
  class: "questionnaire__status questionnaire__status--ongoing"
}
const _hoisted_10 = { class: "questionnaire__status__container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "questionnaire__status__top" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Exercício em andamento.")
], -1))
const _hoisted_12 = {
  key: 1,
  class: "questionnaire__status"
}
const _hoisted_13 = { class: "questionnaire__status__container" }
const _hoisted_14 = { class: "questionnaire__status__top" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Exercício finalizado", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Você não atingiu a quantidade de acertos esperada. ")
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "questionnaire__buttons" }
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIViewer = _resolveComponent("TUIViewer")!
  const _component_TimeFormatter = _resolveComponent("TimeFormatter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.currentContent.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_ctx.exercise.isRequired ? "Obrigatório" : "Opcional"), 1),
        _hoisted_5,
        _createElementVNode("span", null, "Tentativas: " + _toDisplayString(_ctx.exercise.attemptLimit ? _ctx.exercise.attemptLimit : "Ilimitado"), 1),
        _hoisted_6,
        _createElementVNode("span", null, "Questões: " + _toDisplayString(_ctx.exercise.numberOfQuestions), 1),
        _hoisted_7,
        _createElementVNode("span", null, "Nota mínima: " + _toDisplayString(_ctx.exercise.minCorrectAnswers ?? 0) + "/" + _toDisplayString(_ctx.exercise.numberOfQuestions), 1),
        _hoisted_8,
        _createElementVNode("span", null, "Tempo máximo: " + _toDisplayString(_ctx.formattedDuration(_ctx.exercise.maximumTime) ?? "Ilimitado"), 1)
      ]),
      _createVNode(_component_TUIViewer, {
        "model-value": _ctx.currentContent.description
      }, null, 8, ["model-value"]),
      _createElementVNode("div", null, [
        (
            _ctx.exercise.status.questionnaire.createdAt &&
              !_ctx.exercise.status.questionnaire.finishedAt
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_TimeFormatter, {
                  key: _ctx.exercise.id,
                  onTimeExpired: _ctx.onTimeExpired
                }, null, 8, ["onTimeExpired"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.exercise.status.finished)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16,
                  _createElementVNode("span", null, "Resultado: " + _toDisplayString(_ctx.exercise.status.questionnaire.questions.corrects) + "/" + _toDisplayString(_ctx.exercise.numberOfQuestions), 1)
                ]),
                (
                _ctx.exercise.attemptLimit &&
                  _ctx.exercise.attemptLimit === _ctx.exercise.status.userAttempts
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Você não possui tentativas restantes. "))
                  : (
                _ctx.exercise.minCorrectAnswers &&
                  _ctx.exercise.status.questionnaire.questions.corrects <
                    _ctx.exercise.minCorrectAnswers
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _hoisted_19,
                        (
                  _ctx.exercise.status.questionnaire.finishedAt &&
                    (!_ctx.exercise.attemptLimit ||
                      (_ctx.exercise.attemptLimit &&
                        _ctx.exercise.attemptLimit > _ctx.exercise.status.userAttempts))
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Tente outra vez! "))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        (!_ctx.exercise.status.questionnaire.createdAt)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "questionnaire__button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickStart && _ctx.onClickStart(...args)))
            }, " Iniciar "))
          : _createCommentVNode("", true),
        (_ctx.exercise.status.doing)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "questionnaire__button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickContinue && _ctx.onClickContinue(...args)))
            }, " Continuar "))
          : _createCommentVNode("", true),
        (_ctx.exercise.status.doing && !_ctx.exercise.status.finished)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "questionnaire__button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickFinish && _ctx.onClickFinish(...args)))
            }, " Finalizar "))
          : _createCommentVNode("", true),
        (
            (_ctx.exercise.status.questionnaire.finishedAt &&
              (!_ctx.exercise.attemptLimit ||
                (_ctx.exercise.attemptLimit &&
                  _ctx.exercise.attemptLimit > _ctx.exercise.status.userAttempts))) ||
              _ctx.exercise.status.questionnaire.inCorrection
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: "questionnaire__button",
              disabled: _ctx.exercise.status.questionnaire.inCorrection,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickRedo && _ctx.onClickRedo(...args)))
            }, _toDisplayString(_ctx.exercise.status.questionnaire.inCorrection
              ? "Em correção"
              : "Refazer"), 9, _hoisted_22))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}